import {useState, useEffect} from 'react'
import axios from 'axios'
import {useParams, Link} from 'react-router-dom'
import { Container } from 'reactstrap'
import ShareContent from '../components/ShareContent'
import Helmet from 'react-helmet'
import ListPromo from '../components/ListPromo'
import PromoLoading from '../components/PromoLoading'
import GetCurrentLang from '../helper/GetCurrentLang'
import FormatPeriod from '../helper/FormatPeriod'
import jsonQuery from 'json-query'
import _ from 'lodash'

interface ParamTypes {
  id: string,
  slug: string
}

interface Data {
  title: {
    rendered: string
  },
  content: {
    rendered: string
  },
  discount: string,
  start_period: string,
  end_period: string,
  thumbnail: any[string],
  cities: any[string],
  logo: any[string],
  fimg_url: string
}

declare global {
  interface Window {
    dataLayer: any
  }
}

const Promo = () => {
  const {id, slug} = useParams<ParamTypes>()
  const [data, setData] = useState<Data[]>([{
    title: {
      rendered: ''
    },
    discount: '',
    start_period: '',
    end_period: '',
    content: {
      rendered: ''
    },
    cities: [],
    thumbnail: [],
    logo: [],
    fimg_url: ''
  }])

  const [related, setRelated] = useState<any>({
    data: []
  })

  const [showLoader, setShowLoader] = useState(true)

  useEffect(() => {
    setShowLoader(true)
    function getRelated(data : any, posts: any) {
      const cats = data[0].categories
      const json = jsonQuery(`[**][*categories=${cats}]`, {
        data: posts,
        allowRegexp: true
      })
      const result = json.value
      setRelated({data : _.shuffle(result).slice(0,4)})
      setTimeout(() => {
        setShowLoader(false)
      }, 500)
    }
    axios.get(`${process.env.PUBLIC_URL}/data/posts-${GetCurrentLang()}.json`)
    .then((resp : any) => {
      const json = jsonQuery(`[**][slug=${slug}]`, {
        data: resp.data,
        allowRegexp: true
      })
      setData([json.value])
      getRelated([json.value], resp.data)
    }).catch((err) => {
      console.log(err)
    })
    
  }, [slug])

  return (
    <>
      <div className="bg-white">
        <Container className="container-smaller">
          <div className={!showLoader ? 'd-none' : ''}>
            <PromoLoading />
          </div>
          {data && data.map((item: Data, i) => {
            return (
              <div key={i} className={`DetailPromo ${showLoader ? 'd-none' : ''}`}>
                <Helmet>
                  <title>{`BCA - ${item.title.rendered.replace('&#8211;', '-')}`}</title>
                </Helmet>
                <div className="mb-5 px-lg-5">
                  <h1 dangerouslySetInnerHTML={{__html: item.title.rendered}} className="promo-title" />
                  <p className="text-grey text-date">{(item.start_period !== '') && FormatPeriod(item.start_period, item.end_period, false)}</p>
                </div>
                <div className="mb-5 featured-media">
                  <img src={item.fimg_url} className="w-100" alt={item.title.rendered}/>
                </div>
                <div className="px-lg-5">
                  <h3>{GetCurrentLang() == 'en' ? 'Promo Location' : 'Lokasi Promo'}</h3>
                  <div className="d-flex mb-4 align-items-center list-location">
                    <i className="a-system-icon is-medium icon-location mr-3"></i>
                    {(item.cities) && (item.cities.map((tag : any) => (
                      <Link to={`/?city=${tag.term_id}`} key={i} className="mr-3 text-decoration-none">{tag.name}</Link>
                    )))}
                  </div>
                  <h2 className="font-weight-bold text-blue sub-title mb-5">{item.discount}</h2>
                  <div dangerouslySetInnerHTML={{__html : item.content.rendered }} className="content-rendered mb-5" />
                  <ShareContent />
                </div>
              </div>
            )
          })}
        </Container>
      </div>
      <div className="RelatedPromo bg-light-blue">
        <Container className="py-5">
          <div className="d-flex justify-content-between">
            <h3>{GetCurrentLang() == 'en' ? 'Similar Promo' : 'Promo Serupa'}</h3>
            <Link to="/" className="align-items-center text-decoration-none d-none d-sm-flex"><span className="mr-2">{GetCurrentLang() == 'en' ? 'All Promo' : 'Lihat Promo Lainnya'}</span> <i className="a-system-icon icon-chevron-next"></i></Link>
          </div>
          <ListPromo {...related} className="mb-4" />
          <div className="d-flex justify-content-center d-sm-none py-5">
            <Link to="/" className="align-items-center text-decoration-none d-flex"><span className="mr-2">{GetCurrentLang() == 'en' ? 'All Promo' : 'Lihat Promo Lainnya'}</span> <i className="a-system-icon icon-chevron-next"></i></Link>
          </div>
        </Container>
      </div>
    </>
  )
}

export default Promo